import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_uJqYkcf4q',
      userPoolClientId: 'c8mrs1ha6sl87esdjelb00b28',
      loginWith: {
        username: true,
      }
    }
  }
});